export default __webpack_public_path__ + "static/media/edtech.f0f54728.jpeg";